module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default mb-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v("\n                Voltar\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n                                    Novo Peso\n                                    "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('dw-table-header', {
    attrs: {
      "size": _vm.size,
      "pagination": _vm.list
    },
    on: {
      "finish": _vm.updateSize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_c('dw-table-head', {
    attrs: {
      "headers": _vm.headers,
      "editable": true
    },
    on: {
      "update": _vm.sort
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.list.rows), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-label": _vm.headers[0].name
      }
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[1].name
      }
    }, [_vm._v(_vm._s(_vm._f("formatBRL")(item.peso)) + " Kg")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[2].name
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.data, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.edit(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))], 1), _vm._v(" "), _c('dw-pagination', {
    attrs: {
      "pagination": _vm.list,
      "page": _vm.page,
      "offset": _vm.size
    },
    on: {
      "update": _vm.fetchData
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5942d1a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/weight/List.vue
// module id = 869
// module chunks = 1